import request from '@/utils/request'

// 获得菜单(暂停用)
export function getMenuList() {
    return request({
        url: '/gtwg/pc/homePage/column',
        method: 'get'
    })
}
// 首页轮播
export function getBanner() {
    return request({
        url: '/gtwg/pc/homepage/carouselList',
        method: 'get'
    })
}
// 首页新闻
export function getNews() {
    return request({
        url: '/gtwg/pc/homepage/news',
        method: 'get'
    })
}
// 首页中心概况
export function getCore() {
    return request({
        url: '/gtwg/pc/homepage/core',
        method: 'get'
    })
}
// 首页组织建设
export function getOrganization() {
    return request({
        url: '/gtwg/pc/homepage/organization',
        method: 'get'
    })
}
// 首页轮播
export function getBusiness() {
    return request({
        url: '/gtwg/pc/homepage/business',
        method: 'get'
    })
}
// 浏览量
export function addGtAccessRecord(params) {
    return request({
        url: '/gtwg/pc/addGtAccessRecord',
        method: 'get',
        params:params
    })
}
// 搜索
export function searchByKey(data){
    return request({
        url:'/gtwg/pc/search',
        method:'get',
        params:data
    })
}

// 获取ip
export function getIp(params){
    return request({
        url:'https://api.ipify.org?format=json',
        method:'get',
        params
    })
}